import React from "react";
import ScaledLogo from "./ScaledLogo";
import styles from "./materials.module.scss";

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-GB", { month: "long" });
  return `${day}. ${month}`;
};

const InstagramDetails = ({ event, textColor, bgColor }) => (
  <div className={styles.igDetails} style={{ "--mat-bg": bgColor, "--mat-text": textColor }}>
    <div className={styles.igDetailsTextContainer}>
      <span className={styles.igDetailsLabel}>Meetup #{event.eventMeetupNo}</span>
      <div className={styles.igDetailsContent}>
        <p>{formatDate(event.date)}</p>
        <p>kl. {event.timeFrom}</p>
        <p>@ {event.venueName}</p>
        {event.address && <p>{event.address}</p>}
      </div>
    </div>
    <span className={styles.igDetailsFooter}>{"Meetup link in bio "}</span>
    <div className={styles.igDetailsLogo}>
      <ScaledLogo color={event.color} width={192} height={221} />
    </div>
  </div>
);

export default InstagramDetails;
